export const ZapScaleEventsConstants = {
  LOGGED_IN: "Logged In",
  CONFIG_OPEN: "Config Open",
  RECON_MIS_OPEN: "Recon MIS Open",
};
